import * as $ from 'jquery';
import { Component, OnInit, Inject, ViewChild, AfterViewInit, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { serviceUrl } from '../common/serviceconstants';
import { Router, ActivatedRoute } from '@angular/router';
import { GenericHttpClient } from '../Services/Basicauthentication';
import { UtilityServices } from '../UtilityServices';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { ThemePalette } from '@angular/material/core';
import { CurrencyPipe } from '@angular/common'
import { EmitterService } from '../emitterservice';
import { registerables } from 'node_modules/chart.js'
import { Chart } from "chart.js";
import { ChartComponent } from "ng-apexcharts";
import { IDropdownSettings, } from 'ng-multiselect-dropdown';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ChartReadyEvent } from 'angular-google-charts';



import {
  ApexAxisChartSeries,
  ApexNonAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexPlotOptions,
  ApexResponsive,
  ApexLegend,
  ApexFill
} from "ng-apexcharts";
import { pluck } from 'rxjs-compat/operator/pluck';


export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  tooltip:any;
  fontFamily: String;
  fontSize: String;
  fontWeight: String;
  colors: string[];
  fill: any;
  dataLabels: any;
};


export type ChartOptions2 = {
  series: ApexAxisChartSeries;
  chart2: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  responsive: ApexResponsive[];
  xaxis: ApexXAxis;
  // yaxis: ApexYAxis;
  yaxis: ApexYAxis | ApexYAxis[];
  legend: ApexLegend;
  fill: ApexFill;
  name: string[];
  data: any[];
  colors: string[];
};

export type ChartOptions3 = {
  series: ApexAxisChartSeries;
  chart3: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  responsive: ApexResponsive[];
  xaxis: ApexXAxis;
  legend: ApexLegend;
  fill: ApexFill;
  name: string[];
  data: any[];
  colors: string[];
};




type ApexXAxis = {
  type?: "category" | "datetime" | "numeric";
  categories?: any;
  labels?: {
    style?: {
      colors?: string | string[];
      fontSize?: string;
    };
  };
};

type ApexYAxis = {
  type?: "categorytest" | "datetime" | "numeric";
  categoriestest?: any;
  labels?: {
    style?: {
      colors?: string | string[];
      fontSize?: string;
    };
  };
};


@Component({
  selector: 'app-global-dashboard',
  templateUrl: './global-dashboard.component.html',
  styleUrls: ['./global-dashboard.component.css']
})
export class GlobalDashboardComponent implements OnInit,AfterViewInit {

  dropdownList = [];
  dropdownSettings:IDropdownSettings={};
  dropDownForm:FormGroup;
  selectedItems=[];

  dropdownList1 = [];
  dropdownSettings1:IDropdownSettings={};
  dropDownForm1:FormGroup;
  selectedItems1=[];
  
  mode: ProgressBarMode = 'determinate';
  //EmpNumber: any;
  //EmpWorkPhoneNumber: any;
  //EmpName: any;
  //EmpDeptName: any;
  CommunityFramework: any = '0';
  //AgencyOrganizationName: any = '0';



  @ViewChild("chart, { static: true }") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  @ViewChild("chart2, { static: true }") chart2: ChartComponent;
  public chartOptions2: Partial<ChartOptions2>;

  @ViewChild("chart3, { static: true }") chart3: ChartComponent;
  public chartOptions3: Partial<ChartOptions3>;



  constructor(private fb: FormBuilder,private http: HttpClient, private router: Router, private httpClient: GenericHttpClient,
    private utility: UtilityServices, private cp: CurrencyPipe) {

    this.getCommunitygoals();
    this.getFiscalYears();
    this.getDepartments();
    this.displayBarChart();
    this.displayStackedPercentBarChart();
    this.displayDepartmentBarChart();
  }

  chartdata: any;
  public settings = {};
  ngOnInit(): void {
    this.dropdownSettings = {
      idField: 'communityGoalsID',
      textField: 'communityGoalsConcat',
      selectAllText: 'Select All',
     
      itemsShowLimit: 1,
      maxHeight:400
    };
    this.dropDownForm = this.fb.group({
      myItems: [this.selectedItems]
  });

    this.dropdownSettings1 = {
      idField: 'departmentID',
      textField: 'departmentDesc',
      selectAllText: 'Select All',
      itemsShowLimit: 1,
      maxHeight:400
    };
    this.dropDownForm1 = this.fb.group({
      myItems1: [this.selectedItems1]
  });
  setTimeout(()=>{

  this.displayPieChartdata();
}
,500);

  }

  onNavigate() {
    this.router.navigateByUrl('/Resources');
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  communityGoal: any = '';
  communityGoals: any = [];
  getCommunitygoals(): void {
    this.httpClient.get(serviceUrl + '/api/DropDown/GetCommunityGoals',
      '').toPromise<any>().then(response => {
        this.communityGoals = response;
        this.dropdownList = response;
        this.selectedItems = response;
        this.dropDownForm = this.fb.group({
          myItems: [this.selectedItems]
      });
      let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span style="color:#18436b !important;"><b>ALL </b>&nbsp;</span>   </span>    </span>'
    let dhtml = document.querySelectorAll("#CommunityFramework .dropdown-btn");
    if(dhtml.length >0){
      dhtml[0].innerHTML=html;
    }
        //console.log(response);
      });
  }
  cselectedItems = [];
  dselectedItems = [];
  onItemSelect(item: any) {
    //console.log('onItemSelect', item);
    this.items = undefined;
    if(this.cselectedItems.length >1)
    {
    let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span style="color:#18436b !important;"><b>Multiple </b>&nbsp;</span>   </span>    </span>'
    let dhtml = document.querySelectorAll("#CommunityFramework .dropdown-btn");
    if(dhtml.length >0){
      dhtml[0].innerHTML=html;
    }
  } else {
    let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span _ngcontent-dta-c288="">'+item.communityGoalsConcat +'&nbsp;</span>   </span>    </span>'
    let dhtml = document.querySelectorAll("#CommunityFramework .dropdown-btn");
    if(dhtml.length >0){
      dhtml[0].innerHTML=html;
    }
  }
    this.cgoalchange()
}
onItemDeSelect(item: any) {
    //console.log('onItemDeSelect', item);
    this.items = undefined;
    if(this.cselectedItems.length >1)
    {
    let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span style="color:#18436b !important;"><b>Multiple </b>&nbsp;</span>   </span>    </span>'
    let dhtml = document.querySelectorAll("#CommunityFramework .dropdown-btn");
    if(dhtml.length >0){
      dhtml[0].innerHTML=html;
    }
  }
    this.cgoalchange()
}
onSelectAll(items: any) {
   // console.log('onSelectAll', items);
    this.items = items;
    let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span style="color:#18436b !important;"><b>ALL </b>&nbsp;</span>   </span>    </span>'
    let dhtml = document.querySelectorAll("#CommunityFramework .dropdown-btn");
    if(dhtml.length >0){
      dhtml[0].innerHTML=html;
    }
    this.cgoalchange()
}
onUnSelectAll(items: any) {
   // console.log('onUnSelectAll fires',items);
    this.items = items;
    this.cgoalchange()
}

onDropDownClose() {
 // console.log('dropdown closed');
  this.items = undefined;
  setTimeout(() => {
    this.cgoalchange()
    //window.location.reload();
    },20);
    
}
  cgoalchange() {
   // console.log("form data");
   // console.log(this.dropDownForm.value);
   // setTimeout(() => {
      let cid = this.items ?this.items.map(u => u.communityGoalsID).join(','): this.dropDownForm.value.myItems.map(u => u.communityGoalsID).join(',');
    if(this.items && this.items.length == 0){
      cid = "0";
    }
    this.communityGoal = cid;
    let did = this.items1 ?this.items1.map(u => u.departmentID).join(','):this.dropDownForm1.value.myItems1.map(u => u.departmentID).join(',')
    if(this.items1 && this.items1.length == 0){
      if(this.items && this.items.length == 0)
      {
        did = "0";
      } else {
        did="";
       

      }
    }
    this.Department = did;
      EmitterService.get("cgoalid").emit({cid:cid,did:did})
      EmitterService.get("cgoalidprojectlist").emit({cid:cid,did:did})
    //}, 300);
    this.displayPieChartdata();
    this.displayBarChart();
    this.displayDepartmentBarChart();
    this.deptTooltip();
    this.cgoalTooltip();
  }
  donItemSelect(item: any) {
   // console.log('onItemSelect', item);
    this.items1 = undefined;
    if(this.dselectedItems.length >1)
    {
    let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span style="color:#18436b !important;"><b>Multiple </b>&nbsp;</span>   </span>    </span>'
    let dhtml = document.querySelectorAll("#Departments .dropdown-btn");
    if(dhtml.length >0){
      dhtml[0].innerHTML=html;
    }
  } else {
    let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span _ngcontent-dta-c288="">'+item.departmentDesc +'&nbsp;</span>   </span>    </span>'
    let dhtml = document.querySelectorAll("#Departments .dropdown-btn");
    if(dhtml.length >0){
      dhtml[0].innerHTML=html;
    }
  }
    this.cgoalchange()
}
donItemDeSelect(item: any) {
   // console.log('onItemDeSelect', item);
    this.items1 = undefined;
    if(this.cselectedItems.length >1)
    {
    let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span style="color:#18436b !important;"><b>Multiple </b>&nbsp;</span>   </span>    </span>'
    let dhtml = document.querySelectorAll("#Departments .dropdown-btn");
    if(dhtml.length >0){
      dhtml[0].innerHTML=html;
    }
  }
    this.cgoalchange()
}
donSelectAll(items: any) {
    //console.log('onSelectAll', items);
    this.items1 = items;
    let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span style="color:#18436b !important;"><b>ALL </b>&nbsp;</span>   </span>    </span>'
    let dhtml = document.querySelectorAll("#Departments .dropdown-btn");
    if(dhtml.length >0){
      dhtml[0].innerHTML=html;
    }
    this.cgoalchange()
}
donUnSelectAll(items: any) {
    //console.log('onUnSelectAll fires',items);
    this.items1 = items;
    this.cgoalchange()
}
items1:any = undefined;
  deptchange() {
    //setTimeout(() => {
      let cid = this.items ?this.items.map(u => u.communityGoalsID).join(','): this.dropDownForm.value.myItems.map(u => u.communityGoalsID).join(',');
    if(this.items && this.items.length == 0){
      cid = "0";
    }
    this.communityGoal = cid;
    let did = this.items1 ?this.items1.map(u => u.departmentID).join(','):this.dropDownForm1.value.myItems1.map(u => u.departmentID).join(',')
    if(this.items1 && this.items1.length == 0){
      if(this.items && this.items.length == 0)
      {
        did = "0";
      } else {
        did="";
       

      }
    }
    this.Department = did;
      EmitterService.get("deptid").emit({cid:cid,did:did})
      EmitterService.get("deptidprojectlist").emit({cid:cid,did:did})
    //}, 300);
    this.displayPieChartdata();
    this.displayBarChart();
    this.displayDepartmentBarChart();
    this.deptTooltip();
    this.cgoalTooltip();
  }
  FiscalYear: any = 'Total';
  FiscalYears: any = [];
  getFiscalYears(): void {
    this.httpClient.get(serviceUrl + '/api/DropDown/GetFiscalYears',
      '').toPromise<any>().then(response => {
        this.FiscalYears = response;
        // console.log(response);
      });
  }

  Department: any = '';
  departmentDesc: any = [];
  getDepartments(): void {
    this.httpClient.get(serviceUrl + '/api/DropDown/GetDepartments',
      '').toPromise<any>().then(response => {
        this.departmentDesc = response;
        this.dropdownList1 = response;
        this.selectedItems1 = response;
        this.dropDownForm1 = this.fb.group({
          myItems1: [this.selectedItems1]
      });
      let html='<span _ngcontent-dta-c288="" class="selected-item-container ng-star-inserted">    <span _ngcontent-dta-c288="" class="selected-item"><span style="color:#18436b !important;"><b>ALL </b>&nbsp;</span>   </span>    </span>'
      let dhtml = document.querySelectorAll("#Departments .dropdown-btn");
      if(dhtml.length >0){
        dhtml[0].innerHTML=html;
      }
        //console.log(response);
        
      });
  }

  //BAR CHART IMPLEMENTATION FOR INVESTMENTS BY COMMUNITY GOAL
  @ViewChild('chart') chart1!: any;
  @ViewChild('dchart') dchart!: any;
 
  ngAfterViewInit(): void {
    this.cgoalTooltip();
    this.deptTooltip();
  }
cgoalTooltip(){
  const chartContainer =this.chart1.element.nativeElement;

    chartContainer.addEventListener('mouseover', (event: any) => {
     // const row = chartWrapper.getSelection()[0].row;
     setTimeout(() => {
      const tooltip = document.querySelector('.google-visualization-tooltip');
      if(tooltip)
      {

        //console.log( tooltip.innerHTML);
        const tooltip1 = document.querySelectorAll('.google-visualization-tooltip text');
        let i=1;
        let amt:any = "";
        tooltip1.forEach((item) => {
         // console.log(item.innerHTML);
          if(i ==3){
            amt = item.innerHTML;
          }
          i=i+1;
        });
       // console.log(amt);
       // amt= amt.replaceAll("$","");
       if(!amt.includes("$"))
        tooltip.innerHTML = tooltip.innerHTML.replace(amt,"$"+amt);
      }
      // this.tooltipTemplate(this.data);
     },10);
     
    });

    chartContainer.addEventListener('mouseout', (event: any) => {
      const tooltip = document.querySelector('.google-visualization-tooltip');
      if( tooltip)
      tooltip.innerHTML = '';
    });
}

deptTooltip(){
  const chartContainer =this.dchart.element.nativeElement;

    chartContainer.addEventListener('mouseover', (event: any) => {
     // const row = chartWrapper.getSelection()[0].row;
     setTimeout(() => {
      const tooltip = document.querySelector('.google-visualization-tooltip');
      if(tooltip)
      {

        //console.log( tooltip.innerHTML);
        const tooltip1 = document.querySelectorAll('.google-visualization-tooltip text');
        let i=1;
        let amt:any = "";
        tooltip1.forEach((item) => {
         // console.log(item.innerHTML);
          if(i ==3){
            amt = item.innerHTML;
          }
          i=i+1;
        });
       // console.log(amt);
       // amt= amt.replaceAll("$","");
       if(!amt.includes("$"))
        tooltip.innerHTML = tooltip.innerHTML.replace(amt,"$"+amt);
      }
      // this.tooltipTemplate(this.data);
     },10);
     
    });

    chartContainer.addEventListener('mouseout', (event: any) => {
      const tooltip = document.querySelector('.google-visualization-tooltip');
      if( tooltip)
      tooltip.innerHTML = '';
    });
}

  type = 'BarChart';
  data = [
    ['2012', 900, 390, 0],
    ['2013', 1000, 400, 0],
    ['2014', 1170, 440, 200],
    ['2015', 1250, 480, 300],
    ['2016', 1530, 540, 400],
  ];

  columnNames = ['CommunityGoals', 'Asia', 'Europe', 'india'];
  options = {
     title: 'Investments by Community Goal',
     titleTextStyle: {
      fontName: 'Roboto, "Helvetica Neue", sans-serif', // Font for axis title
      fontSize: 16
    },
     legend: {
     textStyle: {  
      fontName: 'Roboto, "Helvetica Neue", sans-serif', 
      fontSize: '14' }
     },
    curveType: 'function',
     tooltip: {
      isHtml: false, // Enable HTML in tooltip content
      trigger: 'both',
      textStyle: {
        fontSize: 14,
        fontFamily:'Roboto, "Helvetica Neue", sans-serif',
      },
      // Define custom tooltip content using a function
      // that returns an HTML string
      // You can customize the tooltip content as per your needs
      formatter:  (tooltipItem: any) => {
        //console.log("tooltip item")
        //console.log(tooltipItem);
        var tooltipText = '<div style="padding: 8px; background-color: #f8f8f8;">' +
          '<b>' + tooltipItem.label + '</b>TEST<br>' +
          'Value: ' +  
          //this.pipe.transform( tooltipItem.value,'USD',true) +
          '</div>';
        return tooltipText;
      }
    },
    // colors: [
    //   '#000370',
    //   '#035904',
    //   '#445774',
    //   '#A95A12',
    //   '#2765DE',
    //   '#7E38CB',
    //   '#1836B7',
    //   '#502F17', 
    //   '#006573',
    //   '#1C4942',
    //   '#158000', 
    //   '#6D3E1E',
    //   '#9A1114'

    // ],
    width: 1500,
    
    hAxis: {
      title: 'Funding Amount (in dollars)',
      titleTextStyle: {
        fontName: 'Roboto, "Helvetica Neue", sans-serif', // Font for axis title
        fontSize: 14
      },
      textStyle: {  
                   fontName: 'Roboto, "Helvetica Neue", sans-serif', 
                   fontSize: '14' }
    },
    

    
    vAxis: {
      minValue: 0,
      maxValue: 100000,
      textStyle: {  
        fontName: 'Roboto, "Helvetica Neue", sans-serif', 
        fontSize: '14' }
    },
    //fontSize: 14,
    fontFamily:'Roboto, "Helvetica Neue", sans-serif',
    isStacked: true,
   // width: 1440,
    height: 720
  };

  

  //BAR CHART IMPLEMENTATION FOR INVESTMENTS BY DEPARTMENTS

  deptdata = [
    ['2012', 900, 390, 0],
    ['2013', 1000, 400, 0],
    ['2014', 1170, 440, 200],
    ['2015', 1250, 480, 300],
    ['2016', 1530, 540, 400],
  ];

  dcolumnNames = ['Departments', 'Asia', 'Europe', 'india'];
  doptions = {
     title: 'Investments by Departments',
     titleTextStyle: {
      fontName: 'Roboto, "Helvetica Neue", sans-serif', // Font for axis title
      fontSize: 16
    },
     legend: {
     textStyle: {  
      fontName: 'Roboto, "Helvetica Neue", sans-serif', 
      fontSize: '14' }
     },
     tooltip: {
      isHtml: false, // Enable HTML in tooltip content
      textStyle: {
        fontSize: 14,
        fontFamily:'Roboto, "Helvetica Neue", sans-serif',
      },
      // Define custom tooltip content using a function
      // that returns an HTML string
      // You can customize the tooltip content as per your needs
      formatter: function (tooltipItem) {
       // console.log("tooltip item")
        //console.log(tooltipItem);
        var tooltipText = '<div style="padding: 8px; background-color: #f8f8f8;">' +
          '<b>' + tooltipItem.label + '</b><br>' +
          'Value: ' +  this.pipe.transform( tooltipItem.value,'USD',true) +
          '</div>';
        return tooltipText;
      }
    },
    // colors: [
    //   '#000370',
    //   '#035904',
    //   '#445774',
    //   '#A95A12',
    //   '#2765DE',
    //   '#7E38CB',
    //   '#1836B7',
    //   '#502F17', 
    //   '#006573',
    //   '#1C4942',
    //   '#158000', 
    //   '#6D3E1E',
    //   '#9A1114'

    // ],
    width: 1500,
    hAxis: {
      title: 'Funding Amount (in dollars)',
      titleTextStyle: {
        fontName: 'Roboto, "Helvetica Neue", sans-serif', // Font for axis title
        fontSize: 14
      },
      textStyle: {  
                   fontName: 'Roboto, "Helvetica Neue", sans-serif', 
                   fontSize: '14' }
    },
    vAxis: {
      minValue: 0,
      maxValue: 100000,
      textStyle: {  
        fontName: 'Roboto, "Helvetica Neue", sans-serif', 
        fontSize: '14' }
    },
    //fontSize: 14,
    fontFamily:'Roboto, "Helvetica Neue", sans-serif',
    isStacked: true,
   // width: 1440,
    height: 720
  };


  cbchartVisible = true;
  displayBarChart() {
    this.httpClient.get(serviceUrl + '/api/Community/GetNonProfitTotalsGoalsDept', {CommunityGoalID:this.communityGoal, DepartmentID:this.Department}
    ).toPromise<any>().then(response => {
      //console.log(response);
      if(response.length > 0)
      {
       this.cbchartVisible = true;
      let cgoals = [];
      let cgoal = [];
      let depts = [];
      this.data = [];
      this.columnNames = [];
      this.columnNames.push("CommunityGoals")
      
      let groupBycommunityGoal = response.reduce((group, row) => {
        const { communityGoal } = row;
        group[communityGoal] = group[communityGoal] ?? [];
        group[communityGoal].push(row);
        return group;
      }, {});
     // console.log("groupby");
     // console.log(groupBycommunityGoal);
      let j = 0;
      response.forEach(ele => {
        let c = cgoals.filter(r => r == ele.communityGoal);
        j=j+1;
        if (c.length == 0) {
          cgoals.push(ele.communityGoal);

          
         
        } else {
        }


        let d = depts.filter(r => r == ele.department);
        if (d.length == 0) {
          if (ele.department != "") {
            depts.push(ele.department)
            this.columnNames.push(ele.department)
          }
        } else {
          
        }


        
      });
     //this.columnNames.push("{ role: 'tooltip', type: 'string', p: {html: true} }");
     // console.log("columns");
     // console.log(this.columnNames);
     // console.log(this.data);
     // console.log(cgoals);
     //console.log("print")
      cgoals.forEach(r => {
        //console.log(groupBycommunityGoal[r]);
       // this.data.push( r);
        let cdata = []
        cdata.push(r);
        depts.forEach(d => {
         let m = groupBycommunityGoal[r].filter(a => a.department == d);
         if(m.length > 0){
          cdata.push(m[0].yearItems.filter(p => p.fiscalYear == this.FiscalYear)[0].amount)
         }
         else {
          let z:any =0;
          cdata.push(z);
         }
        
        })
       // cdata.push("tooltip1");
        this.data.push( cdata);
      });
      //console.log("grouped modified data");
      //console.log(this.columnNames);
      //console.log(this.data);
      //console.log(cgoals);

      this.data.forEach(r => {
        let i = r.length;
        for (i; i < this.columnNames.length; i++) {
          r.push(0);
        }
      })
      //console.log(this.data);
      let i = 0;
      cgoals.forEach(r => {
        i = i + 1;
        cgoal.push(i);
      })
      
     
    }
    else {
      this. cbchartVisible = false;

    }
    });


  }
  
  dbchartVisible = true;
  displayDepartmentBarChart() {
    this.httpClient.get(serviceUrl + '/api/Community/GetNonProfitTotalsDeptGoals', {CommunityGoalID:this.communityGoal, DepartmentID:this.Department}
    ).toPromise<any>().then(response => {
      //console.log(response);
      if(response.length > 0)
      {
        this.dbchartVisible= true;
      let cgoals = [];
      let cgoal = [];
      let depts = [];
      this.deptdata = [];
      this.dcolumnNames = [];
      this.dcolumnNames.push("Departments")
      
      let groupBydepartment = response.reduce((group, row) => {
        const { department } = row;
        group[department] = group[department] ?? [];
        group[department].push(row);
        return group;
      }, {});
      //console.log("deptgroupby");
      //console.log(groupBydepartment);
      let j = 0;
      response.forEach(ele => {
        let c = cgoals.filter(r => r == ele.communityGoal);
        j=j+1;
        if (c.length == 0) {
          cgoals.push(ele.communityGoal);
          this.dcolumnNames.push(ele.communityGoal)
          
         
        } else {
          
        }


        let d = depts.filter(r => r == ele.department);
        if (d.length == 0) {
          if (ele.department != "") {
            depts.push(ele.department)
           
          }
        } else {
          
        }


        
      });
     
      //console.log("columns");
      //console.log(this.dcolumnNames);
      //console.log(this.deptdata);
      //console.log(cgoals);
     //console.log("print")
     depts.forEach(r => {
       // console.log(groupBydepartment[r]);
       // this.data.push( r);
        let cdata = []
        cdata.push(r);
        cgoals.forEach(d => {
         let m = groupBydepartment[r].filter(a => a.communityGoal == d);
         if(m.length > 0){
          cdata.push(m[0].yearItems.filter(p => p.fiscalYear == this.FiscalYear)[0].amount)
         }
         else {
          let z:any =0;
          cdata.push(z);
         }
        })
        this.deptdata.push( cdata);
      });
      //console.log("grouped modified data");
      //console.log(this.dcolumnNames);
      //console.log(this.deptdata);
      //console.log(cgoals);

      this.deptdata.forEach(r => {
        let i = r.length;
        for (i; i < this.dcolumnNames.length; i++) {
          r.push(0);
        }
      })
      //console.log(this.data);
      let i = 0;
      cgoals.forEach(r => {
        i = i + 1;
        cgoal.push(i);
      })
      
    } else {
      this.dbchartVisible= false;
    }

    });
    


  }


  fyearchange() {
    this.displayPieChartdata();
    this.displayBarChart();
    this.displayDepartmentBarChart();
    this.deptTooltip();
    this.cgoalTooltip();
  }


  display: boolean = false;
  items:any = undefined;
  displayPieChartdata() {
   // console.log("form data1 ")
   // console.log(this.dropDownForm.value.myItems);
   // console.log(this.dropDownForm1.value.myItems1);
    //console.log(
    //  this.dropDownForm.value.myItems.map(u => u.communityGoalsID).join(',').toString()
   // );
    let cid = this.items ?this.items.map(u => u.communityGoalsID).join(','): this.dropDownForm.value.myItems.map(u => u.communityGoalsID).join(',');
    if(this.items && this.items.length == 0){
      cid = "0";
    }
    let did = this.items1 ?this.items1.map(u => u.departmentID).join(','):this.dropDownForm1.value.myItems1.map(u => u.departmentID).join(',')
    if(this.items1 && this.items1.length == 0){
      if(this.items && this.items.length == 0)
      {
        did = "0";
      } else {
        did="";
       

      }
    }
    this.httpClient.get(serviceUrl + '/api/Community/GetNonProfitInvestmentTotals', { CommunityGoalID:cid, DepartmentID:did}
    ).toPromise<any>().then(response => {
      let cgoal = [];
      let totalamounts = [];
      let colors = [];
      if(response.length == 0){
      this.investmenttotalsmessage = "No Information availble at this time. Please try again later."

      } else {
        this.investmenttotalsmessage ="";// "No Information availble at this time. Please try again later."
      }
      response.forEach(element => {
        let a = element.communityGoal.split(".");
        let r = this.communityGoal.split(",");
        //let cgoalexists = (r.length>0 && a.length > 0)? r.filter(r => r == a[0]):[];
        r.forEach( cg => {
        if ((a.length > 0 && a[0] == cg) || this.communityGoal == "") {
          cgoal.push(element.communityGoal)
          totalamounts.push(element.yearItems.filter(p => p.fiscalYear == this.FiscalYear)[0].amount);

          if (a.length > 0 && a[0] == 1) {
            colors.push('#6ce5e8')
          } else if (a.length > 0 && a[0] == 2) {
            colors.push('#2f5f98')
            //colors = ['#2f5f98']
          }
          else if (a.length > 0 && a[0] == 3) {
            colors.push('#2d8bba')
            //colors = ['#2d8bba']
          }
          else if (a.length > 0 && a[0] == 4) {
            colors.push('#41b8d5')
            //colors = ['#41b8d5']
          }
          else if (a.length > 0 && a[0] == 5) {
            colors.push('#ff91fb')
            //colors = ['#ff91fb']
          }
          else if (a.length > 0 && a[0] == 6) {
            colors.push('#bc99fd')
            //colors = ['#bc99fd']
          }
          else if (a.length > 0 && a[0] == 7) {
            colors.push('#ddbfff')
            //colors = ['#ddbfff']
          }
          else if (a.length > 0 && a[0] == 8) {
            colors.push('#9B3192')
            //colors = ['#9B3192']
          }
          else if (a.length > 0 && a[0] == 9) {
            colors.push('#914ca6')
            //colors = ['#914ca6']
          }
          else if (a.length > 0 && a[0] == 10) {
            colors.push('#cd4ddd')
            //colors = ['#cd4ddd']
          }
          if (this.communityGoal == "") {
            colors = [
              '#6ce5e8',
              '#2f5f98',
              '#2d8bba',
              '#41b8d5',
              '#ff91fb',
              '#bc99fd',
              '#ddbfff',
              '#9B3192',
              '#914ca6',
              '#cd4ddd']
          }
        }
      });
      });
      let pipe = this.cp;
      //console.log("cgoal");
      //console.log(cgoal)
      this.chartOptions = {
        series: totalamounts,
        chart: {
          width: 890,
          fontFamily: 'Roboto, "Helvetica Neue", sans-serif',
          type: "pie",
         
          toolbar: {
            show: false
          },
          zoom: {
            enabled: true
          },
          

        },
        colors: colors,
        labels: cgoal,
        
          // tooltip: {
          //   x: {
          //    format: 'dd/MM/yyyy',
          //   },
          //   custom: ({ totalamounts, seriesIndex, dataPointIndex, w }) => {
          //     return `<div class="custom-tooltip">${ pipe.transform(totalamounts[seriesIndex][dataPointIndex],'USD',true)} </div>`;
          //   }
          // },
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {
            //console.log("tooltip");
           // console.log(series);
           // console.log(seriesIndex);
           // console.log(dataPointIndex);
           // console.log(w);
            return (
              '<div class="arrow_box">' +
              "<span>" +
               w.config.labels[seriesIndex] +
               ": " +
              pipe.transform(series[seriesIndex],'USD',true)
               +
              " </span>" +
              "</div>"
            );
          }
        },
        
      

        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100]
          },

          

          legend: {
           // fontSize: "32px",
            show: true,
            showForSingleSeries: false,
            showForNullSeries: true,
            showForZeroSeries: true,
            position: 'bottom',
            horizontalAlign: 'center',
            floating: false,
            fontSize: '20px',
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: "bold",
            itemMargin: {
              horizontal: 5,
              vertical: 0
            },
            onItemClick: {
              toggleDataSeries: true
            },
            onItemHover: {
              highlightDataSeries: true
            },
          }
        },

        dataLabels: {
          enabled: true,
          style: {
            fontSize: "140px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: "bold"
          },
          //fontFamily: 'Roboto, "Helvetica Neue", sans-serif',
          
          enabledOnSeries: undefined,

          tooltip: {
            y: {
              formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                return `${w.config.labels[dataPointIndex]}: ${value}%`;
              },
            },
          },
          formatter: function (val, opts) {
            return pipe.transform(val, 'USD', true) 
          },
          textAnchor: 'start',
          distributed: false,
          offsetX: 0,
          offsetY: 0,
          // style: {
          //   fontSize: '20px',
          //   fontFamily: 'Helvetica, Arial, sans-serif',
          //   fontWeight: 'bold',
          //   colors: undefined
          // },




        },
       
      
        responsive: [
          {
            breakpoint: 768,
            options: {
              chart: {
                width: 400
              },
              legend: {
                position: "bottom"
              }
            }
          }
        ]





      };

      //console.log(response)
      this.display = true;
      // } else {
      //}
    });
  }
  investmenttotalsmessage: any;


  keyDownFunction($event) {
  }

  searchdashboard() {
    window.location.reload()
  }

  Clearform() {
    window.location.reload()
  }

  yearFormat(y){
   return y = "FY " + y + "-" +(y+1).toString().substring(2, 4);
  }


  displayStackedPercentBarChart() {
    this.httpClient.get(serviceUrl + '/api/Community/GetNonProfitTotalsDeptGoals', {}
    ).toPromise<any>().then(response => {
      let cgoals = [];
      let cgoal = [];
      let depts = [];
      let ctempgoals = []

      let dseries: ApexAxisChartSeries = [];
      let datac = [];
      response.forEach(ele => {
        let c = cgoals.filter(r => r == ele.communityGoal);
        if (c.length == 0) {
          cgoals.push(ele.communityGoal);
          dseries.push({ name: ele.communityGoal, data: [ele.yearItems.filter(p => p.fiscalYear == "Total")[0].amount] })
          if (datac.length > 0) {
            datac = [];
          }
          let arr = ele.communityGoal.split(".");
          if (arr.length > 0)
            datac.push(arr[0]);
          datac.push(ele.yearItems.filter(p => p.fiscalYear == "Total")[0].amount);
        } else {
        }


        let d = depts.filter(r => r == ele.department);
        if(d.length == 0){
          if (ele.department != "") {
            depts.push(ele.department)
          }
        } else{
          if(ele.department != ''){
            let r = dseries.filter(row => row.name == ele.communityGoal)
          if(r.length > 0)
          r[0].data.push(ele.yearItems.filter(p => p.fiscalYear == "Total")[0].amount);
          }
        }
        let f = ctempgoals.filter(r => r == ele.communityGoal);
        if (f.length == 0) {
          if (ele.communityGoal != "") {
          }
        } else {
        }

      });
      let itemp =0;
      dseries.forEach(r => {
        let i = r.data.length;
        itemp=i;
        for (i; i < cgoals.length; i++) {
          let f :any =0;
          r.data.push(f);
        }
      })
      //console.log("test");
      //console.log(dseries);
      
      let i = 0;
      cgoals.forEach(r => {
        i = i + 1;
        cgoal.push(i);
      })
      // console.log("series");
      // console.log(dseries)

      this.chartOptions3 = {
        series: dseries,
        chart3: {
          type: "bar",
          height: 650,
          stacked: true,
          stackType: "100%"
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0
              }
            }
          }
        ],
        xaxis: {
          categories: depts
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: "right",
          offsetX: 0,
          offsetY: 50
        }
      };

    });


  }


}


